<template>
  <div>
    <loading-container v-if="loading"></loading-container>

    <div v-else>
      <headline-container :headline="publication.attributes.name" :breadcrumbs="breadcrumbs"></headline-container>

      <sub-menu :publication="publication"></sub-menu>

      <router-view v-model="publication"></router-view>
    </div>
  </div>
</template>

<script>
import http from "../../../../http";
import modal from "../../../../modal";
import notify from "../../../../notify";
import HeadlineContainer from "../../../../components/Layout/HeadlineContainer";
import Load from "../../../../mixins/Load";
import LoadingContainer from "../../../../components/Layout/LoadingContainer";
import SubMenu from "./SubMenu";

export default {
  components: {HeadlineContainer, LoadingContainer, SubMenu},

  mixins: [Load],

  props: ['publicationId'],

  data() {
    return {
      publication: null,

      loading: true
    }
  },

  mounted() {
    http.get('/api/v2/publications/' + this.publicationId).then(response => {
      this.publication = response.data.data

      this.loading = false
    })
  },

  computed: {
    breadcrumbs() {
      return [{url: '/publications', text: 'Publications'}, {text: this.publication.attributes.name}];
    }
  },

  methods: {
    destroy() {
      modal.confirm('Are you sure that you want to delete the publication?', () => {
        http.delete('/api/v2/publications/' + this.publication.id)
            .then(() => {
              notify.success('The publication was deleted');

              this.$router.push('/publications');
            });
      });
    }
  }
}
</script>
